module.exports = __webpack_public_path__ + "img/corner-down-right.65fdd247.svg";